import React from "react";

import { AW23 } from "../../../../js/database/database-aw23-eshop.js";

import ProductsContainer from "../../../../components/containers/ProductsContainer.js";
import { SwiperSlide } from "swiper/react";

const SignatureTank = () => {
  return (
    <ProductsContainer
      pageTitle={AW23.tops.SignatureTank.itemName}
      name={AW23.tops.SignatureTank.itemName}
      price={AW23.tops.SignatureTank.itemPrice}
      fabric={AW23.tops.SignatureTank.itemFabric}
      src={AW23.tops.SignatureTank.sizeChart}
      divId={AW23.tops.SignatureTank.shopifyDivId}
      mainId={AW23.tops.SignatureTank.shopifyId}
      buttonShouldHide={true}
    >
      {React.Children.toArray(
        AW23.tops.SignatureTank.pictures.map(({ srcJpeg }) => (
          <SwiperSlide>
            <img
              src={srcJpeg}
              alt={AW23.tops.SignatureTank.itemName}
              width={AW23.imgWidth}
              height={AW23.imgHeight}
              loading={AW23.loading}
            />
          </SwiperSlide>
        ))
      )}
    </ProductsContainer>
  );
};

export default SignatureTank;
